import React from 'react';
import {ADDRESS_TYPES, COUNTRIES, STATE_LABELS, statesForCountry} from '../constants/address';

const EMPTY_ADDRESS = { type: 'HOME', line1: '', line2: '', line3: '', city: '', state: '', zip: '', country: 'US' };

export default function AddressForm({ addresses = [], onChange }) {
  const add = () => onChange([...addresses, { ...EMPTY_ADDRESS }]);
  const remove = (i) => onChange(addresses.filter((_, idx) => idx !== i));
  const update = (i, field, value) => {
    const updated = addresses.map((a, idx) => {
      if (idx !== i) return a;
      const next = { ...a, [field]: value };
      if (field === 'country') next.state = '';
      return next;
    });
    onChange(updated);
  };

  const input = "w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-600";
  const select = "px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-600";

  return (
    <div className="space-y-3">
      {addresses.map((a, i) => (
        <div key={i} className="p-3 border border-gray-200 rounded-lg space-y-2">
          <div className="flex items-center justify-between">
            <select value={a.type} onChange={(e) => update(i, 'type', e.target.value)} className={select}>
              {ADDRESS_TYPES.map(t => <option key={t} value={t}>{t.charAt(0) + t.slice(1).toLowerCase()}</option>)}
            </select>
            <button type="button" onClick={() => remove(i)} className="text-gray-400 hover:text-blue-600 px-2">&times;</button>
          </div>
          <input type="text" placeholder="Line 1" value={a.line1} onChange={(e) => update(i, 'line1', e.target.value)} className={input} />
          <input type="text" placeholder="Line 2" value={a.line2} onChange={(e) => update(i, 'line2', e.target.value)} className={input} />
          <input type="text" placeholder="Line 3" value={a.line3} onChange={(e) => update(i, 'line3', e.target.value)} className={input} />
          <div className="grid grid-cols-2 gap-2">
            <input type="text" placeholder="City" value={a.city} onChange={(e) => update(i, 'city', e.target.value)} className={input} />
            <select value={a.state} onChange={(e) => update(i, 'state', e.target.value)} className={`w-full ${select}`}>
              <option value="">State/Province</option>
              {statesForCountry(a.country).map(s => <option key={s} value={s}>{STATE_LABELS[s] || s}</option>)}
            </select>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <input type="text" placeholder="ZIP / Postal code" value={a.zip} onChange={(e) => update(i, 'zip', e.target.value)} className={input} />
            <select value={a.country} onChange={(e) => update(i, 'country', e.target.value)} className={`w-full ${select}`}>
              {COUNTRIES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
            </select>
          </div>
        </div>
      ))}
      <button type="button" onClick={add} className="text-sm text-blue-600 hover:text-blue-800">+ Add address</button>
    </div>
  );
}
